const jaLang = {
  header: {
    setting: '設定',
    fullScreen: 'フルスクリーン',
    exitFullScreen: 'フルスクリーンを終了',
    userCenter: 'センター',
    logout: 'アカウントを終了',
    langLabel: '言語',
    zhTip: '中国語',
    enTip: 'English',
    jaTip: '日本語',
    koTip: '韓国語'
  },
  home: {
    welcome: 'BiYiバックグラウンド管理システムテンプレートをご利用ください',
    versionDoc: '新しいバージョンの文書説明'
  }
}

export default jaLang
